/* Tusq · Cart Drawer Scroll Fix (v2)
 *
 * Previous version forced scrollTop on .drawer__inner which broke when we
 * added the upsell strip + free-shipping bar (they introduced a new
 * scrollable child container). This version walks up from the event target
 * to find the FIRST element with overflow: auto/scroll that actually has
 * scrollable content, and assigns scrollTop there.
 *
 * Bonus: respects horizontal scroll on the cart upsell rail so wheel scroll
 * doesn't accidentally fight the rail's own horizontal swipe.
 */
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#CartDrawer') ||
    document.querySelector('.cart-drawer');

  if (!cartDrawer) return;

  function findScrollableAncestor(node, root) {
    let n = node;
    while (n && n !== root && n !== document.body) {
      // Only consider HTMLElements (skip text nodes)
      if (n.nodeType === 1) {
        const style = window.getComputedStyle(n);
        const oy = style.overflowY;
        const canScroll = (oy === 'auto' || oy === 'scroll') &&
                          n.scrollHeight > n.clientHeight + 1;
        if (canScroll) return n;
      }
      n = n.parentNode;
    }
    return root.querySelector('.drawer__inner') ||
           root.querySelector('.drawer__contents') ||
           root;
  }

  function onWheelCapture(event) {
    // Only when the drawer is actually open AND the event is inside it
    if (!cartDrawer.contains(event.target)) return;
    if (cartDrawer.classList && cartDrawer.classList.contains('is-empty')) return;
    if (cartDrawer.hasAttribute('hidden')) return;

    // Don't fight the cart upsell rail's horizontal scroll
    const inRail = event.target.closest && event.target.closest('[data-tusq-cart-upsell-rail]');
    if (inRail && Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

    const scrollEl = findScrollableAncestor(event.target, cartDrawer);
    if (!scrollEl) return;

    // Allow the browser to do its own native scroll if the wheel is already
    // landing on a scrollable element with room to go
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    if (maxScroll <= 0) return;

    event.preventDefault();
    event.stopPropagation();

    // Smoothly nudge in the wheel direction
    scrollEl.scrollTop = Math.max(0, Math.min(maxScroll, scrollEl.scrollTop + event.deltaY));
  }

  document.addEventListener('wheel', onWheelCapture, {
    capture: true,
    passive: false,
  });
});
